import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SiteSettingsProvider } from "@/contexts/SiteSettingsContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Find from "@/pages/Find";
import ProListing from "@/pages/ProListing";
import ProsLanding from "@/pages/ProsLanding";
import Directory from "@/pages/Directory";
import DirectoryState from "@/pages/DirectoryState";
import DirectoryCity from "@/pages/DirectoryCity";
import MyListing from "@/pages/MyListing";
import LeadInbox from "@/pages/LeadInbox";
import Pellets from "@/pages/Pellets";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Dashboard from "@/pages/Dashboard";
import Training from "@/pages/Training";
import Downloads from "@/pages/Downloads";
import Pricing from "@/pages/Pricing";
import Shop from "@/pages/Shop";
import ShopSuccess from "@/pages/ShopSuccess";
import QuotePay from "@/pages/QuotePay";
import Inventory from "@/pages/Inventory";
import { SupportList, SupportDetail } from "@/pages/Support";
import Account from "@/pages/Account";
import Billing from "@/pages/Billing";
import { BillingSuccess, BillingCancel } from "@/pages/BillingResult";
import Admin from "@/pages/Admin";
import { Terms, Privacy, Refund } from "@/pages/Legal";

import "@/App.css";

const TOAST_OPTIONS = {
  style: {
    background: "#0A0A0A",
    border: "1px solid #262626",
    color: "#fff",
    borderRadius: "2px",
    fontFamily: "IBM Plex Sans, sans-serif",
  },
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteSettingsProvider>
          <Toaster position="top-right" theme="dark" toastOptions={TOAST_OPTIONS} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/find" element={<Find />} />
          <Route path="/pro/:slug" element={<ProListing />} />
          <Route path="/pros" element={<Directory />} />
          <Route path="/pros/join" element={<ProsLanding />} />
          <Route path="/pros/:state" element={<DirectoryState />} />
          <Route path="/pros/:state/:city" element={<DirectoryCity />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Public-or-member pages (different content based on auth) */}
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/success" element={<ShopSuccess />} />
          <Route path="/quote/pay/:id" element={<QuotePay />} />
          <Route path="/inventory" element={<Inventory />} />

          {/* Authenticated */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
          <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
          <Route path="/billing/cancel" element={<ProtectedRoute><BillingCancel /></ProtectedRoute>} />

          {/* Member-only */}
          <Route path="/training" element={<ProtectedRoute><Training /></ProtectedRoute>} />
          <Route path="/downloads" element={<ProtectedRoute><Downloads /></ProtectedRoute>} />
          <Route path="/dashboard/listing" element={<ProtectedRoute><MyListing /></ProtectedRoute>} />
          <Route path="/dashboard/leads" element={<ProtectedRoute><LeadInbox /></ProtectedRoute>} />
          <Route path="/dashboard/pellets" element={<ProtectedRoute><Pellets /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><SupportList /></ProtectedRoute>} />
          <Route path="/support/:id" element={<ProtectedRoute><SupportDetail /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />

          {/* Legal */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund-policy" element={<Refund />} />

          <Route path="*" element={<Home />} />
          </Routes>
        </SiteSettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
